import React from "react";

export default function ErrorComponent() {
  return (
    <div className="flex items-center justify-center bg-gray-100 py-5">
      <div className="bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-3xl font-semibold mb-4">
          Oops! Something went wrong.
        </h1>
        <p className="text-gray-600 mb-4">
          We're sorry, but it seems like there was an error.
        </p>
        <p className="text-gray-600">
          Please try again later or contact support.
        </p>
      </div>
    </div>
  );
}
